import Vue from 'vue'
import { Message } from 'element-ui'
function TyMessage(){
	this.success =(msg)=>{
		Message({type:'success',message:msg});
	}
	this.error =(msg)=>{
		Message({type:'error',message:msg});
	}
	this.warning =(msg)=>{
		Message({type:'warning',message:msg});
	}
}
Vue.prototype.$message = new TyMessage();
